import { useMemo } from 'react';

import { usePlatforms } from '@mint-lib/routing-context';

import type {
  PlatformCatalogItem,
  PlatformsDataContainer,
} from '../api/types.js';

export const usePlatformsContainer = () => {
  const { platforms = [] } = usePlatforms({
    excludeDeleted: true,
  });

  const { platformsList, integratedPlatforms, platformsByName } =
    useMemo(() => {
      const platformsList = platforms.map((option) => ({
        name: option.platform,
        label: option.label,
        logo: option.logo,
        isIntegrated: option.isIntegrated,
        type: option.type,
      })) satisfies PlatformCatalogItem[];

      const integratedPlatforms = platformsList.filter(
        ({ isIntegrated }) => isIntegrated,
      );

      const platformsByName = platformsList.reduce(
        (acc, platform) => {
          acc[platform.name] = platform;
          return acc;
        },
        {} as Record<string, PlatformCatalogItem>,
      );

      return {
        platformsList,
        integratedPlatforms,
        platformsByName,
      };
    }, [platforms]);

  const isPending = platformsList.length === 0;

  return {
    isPending,
    data: {
      platformsList,
      integratedPlatforms,
      platformsByName,
    },
  } satisfies { isPending: boolean; data: PlatformsDataContainer };
};
